import { HorizontalBar, mixins } from "vue-chartjs"

export default HorizontalBar.extend({
    mixins: [mixins.reactiveProp],
    watch: {
        yMax: {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        displayMode: {
            type: String,
            required: false
        },
        yMax: {
            type: Number,
            default: 100
        }
    },
    data () {
        return {
            options: {
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const amount = this.$numeral(tooltipItem.xLabel)
                            // if(amount.value() <= 0) return false
                            let unit = "h"
                            if(this.displayMode === "relative") unit = "%"

                            return `${data.datasets[tooltipItem.datasetIndex].label} ${amount.format("0,0")}${unit}`
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: (value, index, values) => {
                                if(this.displayMode === "relative") return this.$numeral(value).format("0,0") + "%"
                                return this.$numeral(value).format("0,0") + "h"
                            }
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
